import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import {
  IWorksheetComponent,
  WorksheetAssociatedTestSection,
  WorksheetBalanceFieldSet,
} from 'Components/Worksheets/Core';
import { GrainSize } from 'Components/Worksheets/MoistureContentWorksheet/types';
import BsPreparationDryingEquipmentSection from './BsPreparationDryingEquipmentSection';
import BsPreparationDryingSpecimenGridSection from './BsPreparationDryingSpecimenGridSection';

let BsPreparationSection: React.FC<IWorksheetComponent> = () => {
  const grainSizeOptions: Array<{ label: string; value: GrainSize }> = [
    { label: 'Fine', value: GrainSize.Fine },
    { label: 'Medium', value: GrainSize.Medium },
    { label: 'Coarse', value: GrainSize.Coarse },
  ];

  return (
    <>
      <ListFieldSection heading="Sample Properties">
        <Field input={<RadioGroup />} name="Preparation.SoilGrainSize" options={grainSizeOptions} />
      </ListFieldSection>

      <ListFieldSection heading="Sample Mass">
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<NumericInput />} name="Preparation.TareMass" />
        <Field input={<NumericInput />} name="Preparation.TarePlusSampledMass" />
        <Field input={<TextOutput />} name="Preparation.SampledMass" />
      </ListFieldSection>

      <WorksheetAssociatedTestSection
        heading="Preparation Process"
        name="Preparation.AssociatedOversizeDetermination"
        testType="Particle Density"
        associatedTestModel={{
          measured: true,
        }}
      />

      <SectionGroup heading="Specimen Drying">
        <BsPreparationDryingEquipmentSection />
        <BsPreparationDryingSpecimenGridSection />
      </SectionGroup>
    </>
  );
};

BsPreparationSection = withInjectedProps(BsPreparationSection);

export { BsPreparationSection };
export default BsPreparationSection;
